import axios from 'axios';

export default class API {

	static getDevices({host, token, organization_id, onSuccess, onError}){
		axios.get(`${host}/api/${organization_id}/sensors_emergencies`, 
               {headers: {Authorization: `Token ${token}`}})
				.then((response) => {
					onSuccess(response);
				})
				.catch((error) => {
					onError(error);
				});
	}

	static getPublicMap({host, token, pmap_token, organization_id, onSuccess, onError}){
		axios.get(`${host}/api/${organization_id}/get_public_map`, { 
                 headers: {Authorization: `Token ${token}`},
                 params: { public_map_token: pmap_token }  // クエリパラメータとして追加
               })
				.then((response) => {
					onSuccess(response);
				})
				.catch((error) => {
					onError(error);
				});
	}

  static createEmergency({host, token, organization_id, phone_number, email, lat, lon, location, triage, no, onSuccess, onError}){
    axios.post(`${host}/api/${organization_id}/emergencies`, 
          {
            "phone_number": phone_number,
            "email": email,
            "location": location,
            "lat": lat,
            "long": lon,
            "triage": triage,
            "no": no,
            "is_completed": false,
          },
          {
						headers: {
							Authorization: `Token ${token}`,
							'Content-Type': 'application/json',
							"Access-Control-Allow-Origin": "*",
						}
					})
        .then((response) => {
          onSuccess(response);
        })
        .catch((error) => {
          onError(error);
        });
  }

  static updateEmergency({host, token, organization_id, phone_number, lat, lon, location, triage, id, onSuccess, onError}){
    axios.patch(`${host}/api/${organization_id}/emergencies/${id}`, 
          {
            "lat": lat,
            "long": lon,
            "id": id,
          },
          {
						headers: {
							Authorization: `Token ${token}`,
							'Content-Type': 'application/json',
							"Access-Control-Allow-Origin": "*",
						}
					})
        .then((response) => {
          onSuccess(response);
        })
        .catch((error) => {
          onError(error);
        });
  }

  static getStatus({host, token, organization_id, id, onSuccess, onError}){
    axios.get(`${host}/api/${organization_id}/emergencies/${id}`, 
          {
						headers: {
							Authorization: `Token ${token}`,
							'Content-Type': 'application/json',
							"Access-Control-Allow-Origin": "*",
						}
					})
        .then((response) => {
          onSuccess(response);
        })
        .catch((error) => {
          onError(error);
        });
  }


}
